export enum Logtype {
  INFO = 'Info',
  ERROR = 'Error'
}
